import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const ThailandFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_16018'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_16018)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H20V0H0V2.8Z'
					fill='#F12532'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V11.2H0V14Z'
					fill='#F12532'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#322B6C'
				/>
			</g>
		</svg>
	);
};

export default ThailandFlagIcon;
